const TIPOS_MAQUINAS_NUESTRAS = [
  {
    id: null,
    name: 'Sin máquinas',
  },
  {
    id: false,
    name: 'No',
  },
  {
    id: true,
    name: 'Sí',
  },
]

export {
  TIPOS_MAQUINAS_NUESTRAS
}

